module.exports = __webpack_public_path__ + "img/style_10_en.30a7803b.jpeg";